import { useId, type SVGProps } from "react";

export function GenieLampLogo({ className, title = "VibeGenie", ...props }: SVGProps<SVGSVGElement> & { title?: string }) {
  const id = useId().replace(/:/g, "");
  const glowId = `${id}-glow`;
  const bodyId = `${id}-body`;
  const baseId = `${id}-base`;
  const flameId = `${id}-flame`;

  return (
    <svg viewBox="0 0 96 72" className={className} role="img" aria-label={title} {...props}>
      <defs>
        <radialGradient id={glowId} cx="38%" cy="42%" r="48%">
          <stop offset="0%" stopColor="#FFE36C" />
          <stop offset="48%" stopColor="#F89B33" />
          <stop offset="100%" stopColor="#D54C5E" />
        </radialGradient>
        <linearGradient id={bodyId} x1="24" y1="16" x2="76" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFD85F" />
          <stop offset="44%" stopColor="#F57B32" />
          <stop offset="100%" stopColor="#D94F58" />
        </linearGradient>
        <linearGradient id={baseId} x1="26" y1="52" x2="72" y2="60" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#6B3B8F" />
          <stop offset="62%" stopColor="#9B4A89" />
          <stop offset="100%" stopColor="#E46B4F" />
        </linearGradient>
        <linearGradient id={flameId} x1="18" y1="20" x2="50" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFF06A" />
          <stop offset="100%" stopColor="#FF8A2A" />
        </linearGradient>
      </defs>

      <path
        d="M22.6 49.2c-6.8-6.4-7.6-17.6-1.8-25.6 6.3-8.6 18.8-11.6 29.8-6.1 8.3 4.1 12.9 11 12.5 18.5-.5 10.3-10.2 18.2-22.9 18.5-7.1.1-13.4-1.8-17.6-5.3Z"
        fill={`url(#${glowId})`}
      />
      <path
        d="M28 21.8c9.5-3.3 21.4-.7 29.7 6.4l9.1 7.8c4.3 3.7 10.3 4.7 15.6 2.6l2.9-1.1-1.5 5.7c-1.4 5.1-6.5 8.2-11.7 7.1l-10.4-2.2c-5.1 6-14.5 9.4-25.4 8.7-13.3-.8-23.7-8.6-24-18-.3-7.3 5.6-13.9 15.7-17Z"
        fill={`url(#${bodyId})`}
      />
      <path
        d="M22.9 47.1c7.3 6.3 22.8 7.2 32.6 1.8 3.7-2 6.4-4.9 7.6-8.2 1.6 4.3-.3 9.2-5.1 12.8-8.1 6.2-24.1 7.4-34.3 2.5-5.4-2.6-8.5-6.4-8.4-10.4 2.1.1 4.6.6 7.6 1.5Z"
        fill={`url(#${baseId})`}
      />
      <path d="M25.6 24.4c7.7-4.5 19.7-2.5 27.6 4.5 5.6 5 5.2 13-1 17.2-7 4.7-19.1 3.2-27-3.3-7.5-6.3-7.4-14.1.4-18.4Z" fill={`url(#${flameId})`} />
      <path d="M30.5 28.1c5.4-3.3 14.1-2 19.9 3.1 4.1 3.7 3.8 9.4-.8 12.5-5 3.4-13.7 2.3-19.5-2.5-5.4-4.5-5.3-9.9.4-13.1Z" fill="#FFC547" opacity="0.92" />
      <path d="M62.5 28.6c8.3-5.4 17.4-2.5 17.6 5.1.1 4-3 6.5-6.7 5.6 1.9-.8 3-2.5 2.9-4.6-.3-4.4-5.5-6.1-10.9-3.5l-2.9-2.6Z" fill="#E95850" />
      <path d="M61.1 19.8c3.4-3.8 4.6-7.6 3.3-11.5 4.2 2.3 6.5 6.2 6.1 10.1-.3 2.6-1.7 4.9-4.2 6.8l-5.2-5.4Z" fill="#F16A41" />
      <path d="M72.6 17.6c3.5.2 5.9 2.2 6.2 5.1.4 3.3-2.2 5.9-6 6.2 1.5-1.5 2.1-3.1 1.9-4.7-.2-2-1.4-3.5-3.5-4.4l1.4-2.2Z" fill="#D94F58" />
      <path d="M18.8 52.6c7.4 7.9 30.8 9.4 43 2.6" fill="none" stroke="#5E347D" strokeWidth="4.2" strokeLinecap="round" opacity="0.9" />
      <circle cx="27.5" cy="31.8" r="3.2" fill="#FFF084" opacity="0.78" />
      <path d="M65.8 7.3v8.6M61.5 11.6h8.6" stroke="#FFCA47" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
